export enum SDPStatusEnum {
  ACTIVE = 'ACTIVE',
  WAITING = 'WAITING',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
}
export namespace SDPStatusEnum {
  export const getTranslation = (status: SDPStatusEnum) => {
    switch (status) {
      case SDPStatusEnum.ACTIVE:
        return 'common.available';
      case SDPStatusEnum.WAITING:
        return 'common.waiting';
      case SDPStatusEnum.INACTIVE:
        return 'common.inactive';
      case SDPStatusEnum.EXPIRED:
        return 'common.expired';
      default:
        return 'common.unknown';
    }
  };
}
